import React, {useState} from 'react';

import './HoveredDropDown.css';

const HoveredDropDown = (props) => {
  const [ state, setState ] = useState({
    sortText: props.defaultSelected.text,
    hoverFlag: false,
    hoverActiveClass: 'isHoverActive',
    activeIndex: null,
  });

  const handleSortSel = (item, index) => () => {
    setState({
      ...state,
      sortText: item.text,
      hoverFlag: false,
      activeIndex: index,
    });
    props.onSelected(item);
  };

    return (
      <div className={`advSorterContainer ${props.classNames}`}>
        <p className="latoBold appendBottom15 font14 defaultGreyText">{props.labelName}</p>
        <div
          onMouseEnter={() => setState({ ...state, hoverFlag: true })}
          onMouseLeave={() => setState({ ...state, hoverFlag: false })}>
          <p
            className={`advSorterSelection ${state.hoverFlag ? state.hoverActiveClass + ' activeTile' : ''}`}>
            <span className='defaultGreyText truncate'>
              <span className={`${state.activeIndex != null ? '' : ''}`}>{state.sortText}</span>
            </span>
            <span className={`arrow ${state.hoverFlag ? 'arrow-top-wide ' + state.hoverActiveClass : 'arrow-down-wide'}`}>
                                &nbsp;
            </span>
          </p>
          <ul className={`sortOptions ${state.hoverFlag ? state.hoverActiveClass : ''}`}>
            {
              props.data && props.data.map((item, index) => {
                return (
                  <li
                    key={index}
                    className={`${state.activeIndex === index ? 'selected' : ''}`}
                    onClick={handleSortSel(item, index)}>
                    {item.text}
                  </li>
                );
              })
            }
          </ul>
        </div>
      </div>
    );
  }

export default HoveredDropDown;
